import { api_GET, api_POST, api_PUT } from "../api/_axios.js";

const penalidade_api =
{
    getAll: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`penalidade`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    GetPenalidadesAtivas: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`penalidade/GetPenalidadesAtivas`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getPenalidadesAtivasByConcessionaria: function (concessionaria_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`penalidade/getPenalidadesAtivasByConcessionaria/${concessionaria_Id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    GetPenalidadesAtivasByFormularioConcessionaria: function(concessionaria_Id, formularioVistoria_Id){
        const promise = new Promise((resolve, reject) => {
            api_GET(`penalidade/GetPenalidadesAtivasByFormularioConcessionaria/${concessionaria_Id}/${formularioVistoria_Id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getItem: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`penalidade/getItem/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    post: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`penalidade`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    put: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`penalidade`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default penalidade_api
